<template>
  <div class>
    
  <el-dialog :title="addEditTitle" :visible.sync="addEditShow" width="800px" :before-close="handleChangeDrawer">
    <!-- <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer"> -->
       <el-table :data="parentForm" style="width: 100%">
        <el-table-column prop="oldMobile" label="手机号" width="auto"></el-table-column>
        <el-table-column prop="newMobile" label="修改手机号" width="auto"></el-table-column>
        <el-table-column prop="oxCtime" label="申请时间" width="auto">
          <template slot-scope="scope">
            {{ formatDate(scope.row.oxCtime) }}
          </template>
        </el-table-column>
        <el-table-column prop="date" label="审核时间" width="auto">
          <template slot-scope="scope">
            {{ formatDate(scope.row.oxLtime) }}
          </template>
        </el-table-column>
        <el-table-column prop="auditStatusCn" label="审核结果" width="auto"></el-table-column>
        <el-table-column prop="remark" label="审核备注" width="auto"></el-table-column>
      </el-table>
        <!-- <div class="pay-mains mt10" v-for="item in parentForm" :key="item.id">
          <div class="totals-box">
            <div class="detail">
              <div class="rows">
                <p class="label">手机号</p>
                <p class="num">{{ item.oldMobile }}</p>
              </div>
              <div class="rows">
                <p class="label">修改手机号</p>
                <p class="num">{{ item.newMobile }}</p>
              </div>
              <div class="rows">
                <p class="label">申请时间</p>
                <p class="num">{{ formatDate(item.oxCtime) }}</p>
              </div>
              <div class="rows">
                <p class="label">审核时间</p>
                <p class="num">{{ formatDate(item.oxLtime) }}</p>
              </div>
              <div class="rows">
                <p class="label">审核结果</p>
                <p class="num">{{ item.auditStatusCn }}</p>
              </div>
              <div class="rows">
                <p class="label">审核备注</p>
                <p class="num">{{ item.remark }}</p>
              </div>
            </div>
          </div>
        </div> -->
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="back">返回</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import minxin from "../../assets/javascript/minxin.js";
import drawer from "../../components/common/drawer";
export default {
  mixins: [minxin],
  components: { drawer },
  data() {
    return {
      addEditShow: false,
      addEditTitle: "手机号变更记录",
      dialogHide: false,
      parentForm: []
    };
  },
  created() {
    this.init();
  },
  mounted() {
    
  },
  methods: {
    back() {
      this.addEditShow = false;
    },
    handleChangeDrawer() {
      this.addEditShow = false;
    },
    init() {
      this.$on("set", function(org) {
        this.addEditShow = true;
        this.$api.get(this.$url.member.memberList, {memberId: org.id}).then(res => {
          if (res) {
            this.parentForm = res;
          }
        })
      });
    },

  }
};
</script>
<style scoped lang="less">
@import "../../assets/css/edit.less";
.pay-mains {
  .titles-head {
    border-top: 0;
  }
  .member-msg {
    padding: 15px;
    border-bottom: 2px solid @borderColor;
    display: flex;
  }
  .titles {
    height: 48px;
    font-weight: 500;
    font-size: 18px;
    padding-left: 26px;
    border-bottom: 2px solid @borderColor;
    display: flex;
    align-items: center;
    box-sizing: border-box;
  }
  .totals-box {
    .rows {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 48px;
      padding: 0 26px;
      border-bottom: 2px solid @borderColor;
      .label {
        font-size: 16px;
        font-weight: 400;
        color: #383838;
      }
      .money {
        color: @money;
      }
      .no-money {
        text-decoration: line-through;
      }
      .num {
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
  .pay-methods {
    // padding: 22px 26px 0;
    .title-pay {
      padding: 20px 20px;
      font-size: 18px;
      font-weight: 600;
      // margin-bottom: 20px;
    }
    .methods {
      margin-right: 0.2rem;
      width: 138px;
      height: 108px;
      background-color: #ececed;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .imgs {
        margin-bottom: 0.1rem;
        width: 30px;
        height: 30px;
      }
    }

    .active {
      background-image: url("../../assets/images/money/gou.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-color: @blue;
    }
  }
}
.btns {
  display: flex;
  .btns_total {
    text-align: left;
    margin-right: 40px;
  }
}
/deep/.el-radio-group {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  padding: 0 20px;
  box-sizing: border-box;
  justify-content: space-between;
  .el-radio {
    margin-right: 0;
    text-align: center;
    width: 37%;
    display: flex;
    flex-direction: row-reverse;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    height: 48px;
    border: 1px solid @borderColor;
    border-radius: 10px;
    .el-radio__label {
      display: flex;
      align-items: center;
      flex-direction: row-reverse;
      p {
        width: 100px;
      }
      img {
        width: 32px;
        height: 32px;
      }
    }
    .el-radio__inner {
      width: 22px;
      height: 22px;
    }
  }
}
/deep/ div .el-radio__label {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  width: 60%;
  .label-boxs {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row-reverse;
  }
}
</style>
